export default () => {
	$( window ).scroll( function ( e ) {
		e.preventDefault();
		if ( $( this ).scrollTop() > 50 ) {
			$( '.js-scrol-to-top' ).fadeIn();
		} else {
			$( '.js-scrol-to-top' ).fadeOut();
		}
	} );
	// Scroll body to 0px on click
	$( '.js-scrol-to-top' ).click( function () {
		$( 'body,html' ).animate( {
			scrollTop: 0,
		}, 1500 );

		return false;
	} );
};
